import { combineReducers } from 'redux';

import actions from './actions';
import configuration from './configuration';
import dashboard from './dashboard';
import dropdown from './dropdown';
import isFetchingMarkAllRead from './isFetchingMarkAllRead';
import isPermissionModalOpen from './isPermissionModalOpen';
import unreadIds from './unreadIds';

/**
 * @typedef {{
 *  configuration: import('./configuration').NotificationUIConfigurationReducer
 *  dropdown: import('./dropdown').NotificationUIDropdownReducer
 *  isFetchingMarkAllRead: boolean,
 *  isPermissionModalOpen: boolean,
 * }} NotificationUIReducer
 */

export default combineReducers({
  isFetchingMarkAllRead,
  isPermissionModalOpen,
  configuration,
  dashboard,
  unreadIds,
  dropdown,
  actions,
});
